import * as actionTypes from './actionTypes';

const initialState = {
  title: '',
  message: '',
  coupons: [],
  loading: false,
  error: null,
};

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_AVAILABLE_COUPONS_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.FETCH_AVAILABLE_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        title: action.payload.title,
        message: action.payload.message,
        coupons: action.payload.coupons,
      };
    case actionTypes.FETCH_AVAILABLE_COUPONS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case actionTypes.CLEAR_COUPONS:
      return { ...initialState };
    default:
      return state;
  }
};

export default couponReducer;
